export default __webpack_public_path__ + "c2329cf0792d0cddde2649c9ebaacaf9.svg";